import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ArrowNEIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M18 6.6a1 1 0 0 0-.6-.5L17 6H7a1 1 0 0 0-1 1c0 .5.5 1 1 1h7.6l-8.3 8.3a1 1 0 0 0 0 1.4c.4.4 1 .4 1.4 0l8.4-8.3v7.5c0 .6.4 1 1 1 .4 0 .9-.4.9-1V6.6Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ArrowNEIcon;
